import { useContext } from 'react';

import { PageContext } from 'application/adapters/context/PageContext';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

type PageSettings = (Umbraco.SiteTheme | Umbraco.Navigation | Umbraco.OpenGraph | Umbraco.DynamicNavigation)[] | undefined;

export const useDynamicNavigationLinks = (pageSettings: PageSettings) => {
	const pageContext = useContext(PageContext);
	const dictionary = useContext(DictionaryContext);

	const hasPageLevelDynamicNavigation = pageSettings?.some(
		(setting) => setting.documentType === 'dynamicNavigation' && setting.content?.properties?.useDynamicNavigation,
	);

	const useDynamicNavigation = Boolean(hasPageLevelDynamicNavigation);

	const dynamicLinks: Umbraco.Link[] =
		pageContext.pageType?.page?.children
			?.filter((child) => {
				const navSetting = child.properties.pageSettings?.find((s) => s.documentType === 'navigation');
				return !navSetting?.content.properties.umbracoNaviHide;
			})
			.map((child) => {
				const navSetting = child.properties.pageSettings?.find((s) => s.documentType === 'navigation');
				const { navigationTitle } = navSetting?.content?.properties ?? {};
				return {
					name: navigationTitle ?? child.name,
					url: child.url,
					target: '_self' as const,
				};
			}) ?? [];

	const currentPageTitle = pageContext.pageType?.page?.properties?.title || pageContext.pageType?.page?.name;
	const headingPrefix = dictionary.getValue('DynamicNavigation.MoreTopicsUnder', undefined, 'Flere emner under');
	const heading = currentPageTitle ? `${headingPrefix} '${currentPageTitle}'` : `${headingPrefix} denne side`;

	return {
		useDynamicNavigation,
		dynamicLinks,
		heading,
	};
};
